/* <soh-tabs>: role=tablist with [role=tab][aria-controls]; arrow keys; swipe on mobile; optional [data-tabs-prev]/[data-tabs-next]. */
class SohTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.tabs.forEach((t, i) => { t.addEventListener('click', () => this.select(i)); t.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') this.select(i + 1, true); if (e.key === 'ArrowLeft') this.select(i - 1, true); }); });
    this.querySelector('[data-tabs-prev]')?.addEventListener('click', () => this.select(this.index - 1));
    this.querySelector('[data-tabs-next]')?.addEventListener('click', () => this.select(this.index + 1));
    let x0 = null; const panels = this.querySelector('[data-tabs-panels]') || this;
    panels.addEventListener('touchstart', (e) => x0 = e.touches[0].clientX, { passive: true });
    panels.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) this.select(this.index + (dx < 0 ? 1 : -1)); x0 = null; });
    this.select(Math.max(0, this.tabs.findIndex(t => t.getAttribute('aria-selected') === 'true')));
  }
  select(i, focus) {
    const n = this.tabs.length; this.index = (i + n) % n;
    this.tabs.forEach((t, j) => { const on = j === this.index; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; const p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on; });
    if (focus) this.tabs[this.index].focus();
    this.dispatchEvent(new CustomEvent('soh:tab', { bubbles: true, detail: { index: this.index } }));
  }
}
customElements.define('soh-tabs', SohTabs);
